module.exports = __webpack_public_path__ + "img/组 12 拷贝@2x.149ba907.png";